import { memo } from 'react';
import { Navigate, useMatch, useNavigate } from 'react-router-dom';

import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@doger/ui/components/ui/tabs';

type UserDetailsTabsProps = {
  children: React.ReactNode;
};

const VALID_TABS = ['chats', 'sessions'] as const;
const DEFAULT_TAB = VALID_TABS[0];

export const UserDetailsTabs = memo<UserDetailsTabsProps>(({ children }) => {
  const navigate = useNavigate();
  const userId = useMatch('/users/:userId/*')?.params.userId;
  const tab = useMatch('/users/:userId/:tab/*')?.params.tab;

  if (!tab || !VALID_TABS.includes(tab)) {
    return <Navigate to={`/users/${userId}/${DEFAULT_TAB}`} replace />;
  }

  const activeTab = tab ?? DEFAULT_TAB;

  const handleTabChange = (value: string) => {
    // FUCKING REACT BROKEN ASS ROUTER
    if (VALID_TABS.includes(value)) {
      navigate(`/users/${userId}/${value}`);
    }
  };

  return (
    <Tabs value={activeTab} onValueChange={handleTabChange}>
      <TabsList>
        <TabsTrigger value='chats'>Chats</TabsTrigger>

        <TabsTrigger value='sessions'>Sessions and Devices</TabsTrigger>
      </TabsList>

      <TabsContent value={activeTab}>{children}</TabsContent>
    </Tabs>
  );
});
